import { submitPCFeedbackMockHandler } from '@/features/pc-feedback/api';

export const pcFeedbackHandlers = [submitPCFeedbackMockHandler];
